import Select from 'react-select';
import styled from 'styled-components';

const TopicsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${(props) =>
    props.$isActive
      ? 'padding-bottom: 1rem; border-bottom: 1px solid #cccccc;'
      : ''}

  @media (max-width: 768px) {
    display: ${(props) => (props.$isMobile ? 'flex' : 'none')};
  }
`;

const TopicsWrapper = styled.div`
  width: 100%;
`;

const TopicsLabel = styled.label`
  display: ${(props) => (props.$isActive ? 'block' : 'none')};
  font-size: 0.75rem;
  font-weight: 600;
  color: #666666;
  text-transform: uppercase;
  margin-bottom: 0.25rem;
`;

const selectStyles = {
  control: (base) => ({
    ...base,
    border: '1px solid #cccccc',
    borderRadius: '0.25rem',
    boxShadow: 'none',
    minHeight: '2rem',
    fontSize: '0.875rem',
    '&:hover': {
      border: '1px solid #cccccc',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#212121',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#212121',
    padding: '0 0.5rem 0 0',
    '&:hover': {
      color: '#000000',
    },
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
};

export const ArchiveTopicsFilter = ({
  topics,
  selectedTopics,
  setSelectedTopics,
  isMobile = false,
  isActive = false,
}) => {
  // Handle selection in React Select
  const handleSelectTopic = (option) => {
    if (!option) {
      setSelectedTopics([]);
      return;
    }
    if (!selectedTopics.includes(option.value)) {
      setSelectedTopics([...selectedTopics, option.value]);
    }
  };

  return (
    <TopicsContainer $isMobile={isMobile} $isActive={isActive}>
      <TopicsLabel $isActive={isActive} htmlFor="archive-topics-select">
        Topics
      </TopicsLabel>
      <TopicsWrapper $isMobile={isMobile}>
        <Select
          options={topics}
          onChange={handleSelectTopic}
          value={null}
          placeholder="Topics"
          styles={selectStyles}
          isClearable={true}
        />
      </TopicsWrapper>
    </TopicsContainer>
  );
};
